import request from '@/utils/request';
// 消费统计报表
export function getDataLlist(params) {
  return request({
    url: '/count/consume-stats/index',
    method: 'get',
    params: params
  });
}
// 销售统计报表
export function getSaleStatsLlist(params) {
  return request({
    url: 'count/sale-stats/index',
    method: 'get',
    params: params
  });
}
// 下载
export function exportSaleStats(params) {
  return request({
    url: '/count/sale-stats/download',
    method: 'get',
    params: params
  });
}
// 获取开票说明
export function getInvoiceTips(params) {
  return request({
    url: '/products/page-description/get-invoice-tips',
    method: 'get',
    params: params
  });
}
// 获取渠道列表
export function ordersChannelSale(data) {
  return request({
    url: '/orders/channel/sale',
    method: 'post',
    data: data
  });
}
// 获取开票说明
export function getInvoiceTipsMovieTicketWay(params) {
  return request({
    url: '/products/page-description/get-invoice-tips-movie-ty',
    method: 'get',
    params: params
  });
}